import React from 'react';
import { bool } from 'prop-types';
import classnames from 'classnames';

import { NumProducts } from '../NumProducts/NumProducts';
import { usePromoCart } from '../../../../../../contexts/PromoCartProvider';
import { usePromoModel } from '../../../../../../contexts/PromoModelProvider';
import { formattedReward } from '../../../../../../utils/promo-presentation-utils';
import { PromoViewDetails } from '../../../../../promo-view-details/PromoViewDetails';
import './TierSecondaryMessaging.scss';

export const TierSecondaryMessaging = ({ isInPromoDrawer }) => {
  const { promoSuccessLevel, isPromoAchieved } = usePromoCart();
  const { singleItemIdToDisplay, isMsb, isBmsm, rewardTiers } = usePromoModel();

  const { rewardPercent, rewardAmountPerOrder } = rewardTiers[rewardTiers.length - 1];
  const maxReward = formattedReward({ rewardPercent, rewardAmountPerOrder });

  const bmsmMessageClasses = classnames({ 'promo-tier-secondary-messaging__large-screen-text': isInPromoDrawer });

  return (
    <section data-testid="promo-tier-secondary-messaging">
      {isMsb && (
        <>
          <span>Any combination <NumProducts actionable={!isInPromoDrawer} /></span>
          {promoSuccessLevel === 'almost' && (
            <span className="promo-tier-secondary-messaging__large-screen-text">
              <span>  |  </span>
              <span className="u__bold">Almost There!</span>
            </span>
          )}
          {(isPromoAchieved && !isInPromoDrawer && !singleItemIdToDisplay)
            && <>&nbsp;<span className="u__default-link" type="button">Edit</span></>}
        </>
      )}
      {isBmsm && (
        <>
          <span>
            Save up to {maxReward} Off{' '}
            <span className={bmsmMessageClasses}>Eligible Items </span>
            <NumProducts actionable={!isInPromoDrawer} />
          </span>
          {isInPromoDrawer && (
            <PromoViewDetails isInPromoDrawer={isInPromoDrawer} />
          )}
        </>
      )}
    </section>
  );
};

TierSecondaryMessaging.displayName = 'TierSecondaryMessaging';

TierSecondaryMessaging.propTypes = {
  isInPromoDrawer: bool,
};

TierSecondaryMessaging.defaultProps = {
  isInPromoDrawer: false,
};
